<template>
    <div id="dashboard-users-view">
        <span class="dashboard-title mb-5">Users</span>
        <span class="dashboard-subtitle mb-4">Manage users for "{{ account.organization.name }}" organisation</span>

        <v-tabs background-color="#181818" dark height="40" slider-color="var(--primary)" slider-size="3">
            <v-tab class="ml-n4 mr-15 text-capitalize color-gray">Users</v-tab>
            <v-tab class="mr-15 text-capitalize color-gray" :disabled="!canInviteUsers">Add Users</v-tab>
            <v-tab class="text-capitalize color-gray">Pending Invitations</v-tab>

            <v-tab-item>
                <UsersList :list="activeUsers" />
            </v-tab-item>

            <v-tab-item>
                <AddUsers />
            </v-tab-item>

            <v-tab-item>
                <ManageInvitations :usersList="pendingUsersWithoutGuests" />
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";

import UsersList from "@/components/account/users/List";
import ManageInvitations from '@/components/account/invitations/Manage';
import AddUsers from "@/components/account/users/Add";

import { mapGetters, mapState } from "vuex";

export default {
    name: "UsersListView",
    mixins: [CanMixin],
    components: {
        AddUsers,
        UsersList,
        ManageInvitations
    },

    async created() {
        this.$store.dispatch("User/fetchCurrentPlan");
        this.$store.dispatch("Organizations/fetchUsers");
        this.$store.dispatch("Groups/fetchGroups");
    },

    computed: {
        ...mapState("User", ["account"]),
        ...mapGetters('Organizations', ['activeUsers', 'pendingUsersWithoutGuests']),
    }
};
</script>